import { RawUserPersonalInfoModel } from "../user_personal_info_model.js";

class RawAdminUserContactsInfoModel extends RawUserPersonalInfoModel {

  formFieldsWhitelist(item=undefined) {
    return ["email", "phoneNumber", "mobilePhoneNumber"]
  }

}
const AdminUserContactsInfoModel = new RawAdminUserContactsInfoModel();

export { RawAdminUserContactsInfoModel, AdminUserContactsInfoModel }
